import { useParams } from 'react-router-dom';
import DetailPlanLinkLanding from './DetailPlanLinkLanding';

export const UNIT_PLAN_LINK_PATH = 'unit-plan';

/**
 * Path inside the new Vizzle iframe that shows the unit detail plan page.
 */
export const buildUnitDetailsPath = (unitId) => `/search-lessons/unit-details/${unitId}`;

/**
 * Landing route for a shared unit "Detail Plan Link" (/unit-plan/:unitId).
 *
 * Units are keyed by id everywhere, so no lookup is needed: the link resolves
 * straight to the unit page in its default state. Access and not-found errors
 * are handled by the unit page itself.
 */
export default function UnitPlanLink() {
  const { unitId } = useParams();

  const resolveTarget = async () => (unitId ? buildUnitDetailsPath(unitId) : null);

  return (
    <DetailPlanLinkLanding
      itemName='unit'
      returnPath={`/${UNIT_PLAN_LINK_PATH}/${unitId}`}
      resolveTarget={resolveTarget}
    />
  );
}
